<div class="inner-content">
    <div class="password-change">

        <div class="top-wrapper">
            <img src="assets/icon-user-profile.svg" alt="">
            <p class="name">
                {{ user?.name | default }}
            </p>
            <p class="email">
                {{ user?.email | default }}
            </p>

        </div>


        <form (ngSubmit)="onSubmit()" [formGroup]="form">

            <h2>
                Zmień hasło
            </h2>
            <cmn-label class="dark">
                <input type="password"
                       formControlName="oldPassword"
                       autocomplete="off"
                       placeholder="Obecne hasło"
                       kendoTextBox/>
                <cmn-errors [control]="form.get('oldPassword')"></cmn-errors>

            </cmn-label>
            <cmn-label class="dark">
                <input type="password"
                       formControlName="newPassword"
                       autocomplete="off"
                       placeholder="Podaj nowe hasło"
                       kendoTextBox/>
                <cmn-errors [control]="form.get('newPassword')"></cmn-errors>
            </cmn-label>

            <button type="submit"
                    kendoButton
                    [primary]="true"
                    class="big"
            >
                Ustaw nowe hasło
            </button>

        </form>
    </div>
</div>

<ns-fixed-element position="top">
    <div class="mobile-floater">
        <a routerLink="/">
            Powrót
        </a>
    </div>
</ns-fixed-element>